import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import NameRegister from '@/components/NameRegister';
import Shop from '@/components/Shop';
import Checkout from '@/components/Checkout';
import Address from '@/components/Address';
import NewAddress from '@/components/NewAddress';
import CheckoutSuccess from '@/components/CheckoutSuccess';
import CheckoutStatus from '@/components/CheckoutStatus';
import Orders from '@/components/Orders';
import SupportOrders from '@/components/SupportOrders';
import SupplierOrders from '@/components/SupplierOrders';
import DeliveryOrders from '@/components/DeliveryOrders';
import SupportOrderDetail from '@/components/SupportOrderDetail';
import SupplierOrderDetail from '@/components/SupplierOrderDetail';
import DeliveryOrderDetail from '@/components/DeliveryOrderDetail';
import SalesOrders from '@/components/SalesOrders';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Shop',
      component: Shop,
    },
    {
    	path: '/login/',
    	name: 'Login',
    	component: Login,
    },
    {
    	path: '/name-register/',
    	name: 'NameRegister',
    	component: NameRegister,
    },
    {
    	path: '/shop/',
    	name: 'Shop',
    	component: Shop,
    },
    {
    	path: '/checkout/',
    	name: 'Checkout',
    	component: Checkout,
    },
    {
      path: '/address/',
      name: 'Address',
      component: Address,
    },
    {
      path: '/new_address/',
      name: 'NewAddress',
      component: NewAddress,
    },
    {
      path: '/checkout-success/',
      name: 'CheckoutSuccess',
      component: CheckoutSuccess,
    },
    {
      path: '/orders/',
      name: 'Orders',
      component: Orders,
    },
    {
      path: '/support/orders/',
      name: 'SupportOrders',
      component: SupportOrders,
    },
    {
      path: '/support/order/:id',
      name: 'SupportOrderDetail',
      component: SupportOrderDetail,
    },
    {
      path: '/supplier/:id/orders/',
      name: 'SupplierOrders',
      component: SupplierOrders,
    },
    {
      path: '/supplier/order/:id',
      name: 'SupplierOrderDetail',
      component: SupplierOrderDetail,
    },
     {
      path: '/order/',
      name: 'Order',
      component: CheckoutStatus,
    },
    {
      path: '/delivery/:id/orders/',
      name: 'DeliveryOrders',
      component: DeliveryOrders,
    },
    {
      path: '/delivery/order/:id',
      name: 'DeliveryOrderDetail',
      component: DeliveryOrderDetail,
    },
    {
      path: '/sales/:id/orders/',
      name: 'SalesOrders',
      component: SalesOrders,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js